module.exports = __webpack_public_path__ + "img/pf.b9d2538c.svg";